import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title } from "chart.js";
import { Bar } from "react-chartjs-2";
import { useState, useEffect, useRef } from "react";
import axiApi from "ApiCaller";
import { arrayChoicesToObject } from "views/utils/MutateValues";
import { useTranslation } from "react-i18next";
import Moment from "moment/moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title);

const DoughtSolvedAlerts = () => {
    const [datasets, setDatasets] = useState([]);
    const [labels, setLabels] = useState([]);
    const [total, setTotal] = useState(0);
    const { t: _Tc } = useTranslation("choices");
    const wastes = useRef({});
    const downloads = useRef({});
    const types = useRef({});

    const DataGraph = {
        labels: labels,
        datasets: datasets,
    };

    const OptionsGraph = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
                labels: {
                    usePointStyle: true,
                    pointStyle: "rect",
                    font: {
                        size: 10,
                    },
                },
            },
            title: {
                display: true,
                text: "Alertas resueltas del último mes",
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        const dataset = tooltipItem.dataset;
                        const dataObj = dataset.tooltipData[tooltipItem.dataIndex];
                        if (!dataObj || dataObj.count === 0) return "";
                        let percentage = ((dataObj.count / total) * 100).toFixed(2);
                        return [
                            `Cantidad: ${dataObj.count} (${percentage}%)`,
                            `Dispositivos con alerta: ${dataObj.devicesCount}`
                        ];
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
                beginAtZero: true,
            },
        },
    };

    const pastelColors = [
        "#E8E8E8", "#FFF09F", "#D1EAFF", "#89D894", "#E2B78C",
        "#F4AB75", "#C298EB", "#D1D3D3", "#b1b1b1", "#838383"
    ];

    const pastelBorders = [
        "#707070", "#D3A204", "#064A8B", "#0c6c4a", "#7E4F22",
        "#C96012", "#57227E", "#707070", "#000000", "#2c2c2c"
    ];

    const generateColor = (index) => {
        return pastelColors[index % pastelColors.length];
    };

    const generateBorderColor = (index) => {
        return pastelBorders[index % pastelBorders.length];
    };

    useEffect(() => {
        axiApi
            .get(`/api/home/alerts/resolved/`)
            .then((resp) => {
                if (resp.data.status) {
                    wastes.current = arrayChoicesToObject(resp.data.params.filters.waste);
                    downloads.current = arrayChoicesToObject(
                        resp.data.params.filters.download
                    );
                    types.current = arrayChoicesToObject(resp.data.params.filters.type);

                    const fetchedItems = resp.data.items || [];

                    const weekSet = new Set();
                    const typeSet = new Set();
                    const groupedData = {};

                    fetchedItems.forEach(item => {
                        if (item.resolved_at) {
                            const dateObj = Moment(item.resolved_at);
                            if (dateObj.isValid()) {
                                const weekYear = dateObj.isoWeekYear();
                                const weekNum = dateObj.isoWeek();
                                const sortKey = `${weekYear}-${String(weekNum).padStart(2, '0')}`;
                                const labelStr = `Semana ${weekNum}`;

                                weekSet.add(sortKey);
                                typeSet.add(item.type);

                                if (!groupedData[sortKey]) {
                                    groupedData[sortKey] = { labelStr: labelStr };
                                }
                                if (!groupedData[sortKey][item.type]) {
                                    groupedData[sortKey][item.type] = {
                                        count: 0,
                                        devices: new Set()
                                    };
                                }
                                groupedData[sortKey][item.type].count += 1;
                                if (item.device_uuid) {
                                    groupedData[sortKey][item.type].devices.add(item.device_uuid);
                                }
                            }
                        }
                    });

                    const sortedWeeks = Array.from(weekSet).sort();
                    const newLabels = sortedWeeks.map(k => groupedData[k].labelStr);
                    const newDatasets = [];
                    let newTotal = 0;

                    Array.from(typeSet).forEach((type, index) => {
                        const name = _Tc("alerts_types." + type);
                        const typeData = [];
                        const tooltipDataArray = [];

                        sortedWeeks.forEach(weekKey => {
                            const wData = groupedData[weekKey][type];
                            if (wData) {
                                typeData.push(wData.count);
                                newTotal += wData.count;
                                tooltipDataArray.push({
                                    name: name,
                                    count: wData.count,
                                    devicesCount: wData.devices.size
                                });
                            } else {
                                typeData.push(0);
                                tooltipDataArray.push({
                                    name: name,
                                    count: 0,
                                    devicesCount: 0
                                });
                            }
                        });

                        newDatasets.push({
                            label: name,
                            data: typeData,
                            backgroundColor: generateColor(index),
                            borderColor: generateBorderColor(index),
                            borderWidth: 1,
                            tooltipData: tooltipDataArray
                        });
                    });

                    setLabels(newLabels);
                    setDatasets(newDatasets);
                    setTotal(newTotal);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            });
    }, []);



    return (
        <div className="border" >
            <Bar data={DataGraph} options={OptionsGraph} />
        </div>
    );
};
export default DoughtSolvedAlerts;